import { trackingAxios } from 'config/api/tracking'
import { IOperationModeRepository } from '../../core/domain/IOperationModeRepository'
import { OperationMode } from '../../core/domain/operationMode'
import { OperationModeAdapter, OperationModeApiResponse } from './OperationModeAdapter'

export class AxiosOperationModeRepository implements IOperationModeRepository {
    async getAll(): Promise<OperationMode[]> {
        const response = await trackingAxios.get<OperationModeApiResponse[]>('/classification-types')
        return OperationModeAdapter.toDomainList(response.data)
    }
}
